import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import client from '../api/client';

/**
 * Debounced shop-name lookup (POST /api/market/help/getshopidbyname), shared by
 * Navbar.js (desktop + tablet) and MobileSearchOverlay.js so the search-as-you-type
 * logic isn't duplicated 3 times.
 *
 * Usage:
 *   const apiMatchedShop = useShopSearch(debouncedText);
 */
export function useShopSearch(debouncedText) {
  const { data: shopSearchResult } = useQuery({
    queryKey: ['shop-search', debouncedText],
    queryFn: async () => {
      const formdata = new FormData();
      formdata.append('shop_text', debouncedText);
      const response = await client.post('/api/market/help/getshopidbyname', formdata, {
        headers: { Accept: 'application/json' },
      });
      return response.data;
    },
    enabled: !!debouncedText,
  });

  return useMemo(() => {
    if (!debouncedText || !shopSearchResult) return null;
    if (
      shopSearchResult.status === 'OK' &&
      Array.isArray(shopSearchResult.shop_info) &&
      shopSearchResult.shop_info.length > 0
    ) {
      const shop = shopSearchResult.shop_info[0];
      return {
        shop_id: shop.shop_id,
        shop_name: shop.shop_name,
        shop_province: shop.shop_province || 'กรุงเทพมหานคร',
      };
    }
    return null;
  }, [debouncedText, shopSearchResult]);
}
